
<form [formGroup]="form">
    <div class="row">
        <ca-form-field class="col-4">
            <ca-label>{{'AUTOS.SIMULAR.MARCA' | translate}}</ca-label>
            <input 
                caInput 
                type="text" 
                formControlName="preg_7320"/>
        </ca-form-field>
        <ca-form-field class="col-4">
            <ca-label>{{'AUTOS.SIMULAR.MODELO' | translate}}</ca-label>
            <input 
                caInput 
                type="text"
                formControlName="preg_7321"/>
        </ca-form-field>
        <ca-form-field class="col-4">
            <ca-label>{{'AUTOS.SIMULAR.VERSION' | translate}}</ca-label>
            <input 
                caInput 
                type="text" 
                formControlName="preg_2125" />
        </ca-form-field>
    </div>
    <div class="row mt-3">
        <div class="col-4">
            <ca-form-field>
                <ca-label>{{ 'AUTOS.SIMULAR.USO_VEHICULO.FECHA_PRIMERA_MATRICULACION' | translate }}</ca-label>
                <ca-datepicker 
                    formControlName="preg_1178" 
                    name="preg_1178">
                </ca-datepicker>
            </ca-form-field>
            <ca-error
                *ngIf="form.controls['preg_1178'].errors?.pattern">{{'ERROR.ERROR_FORMATO_FECHA' | translate}}</ca-error>
        </div>
        <ca-form-field class="col-4">
            <ca-label>{{'AUTOS.SIMULAR.USO_VEHICULO.MATRICULA' | translate}}</ca-label>
            <input caInput 
                formControlName="preg_matricula" 
                placeholder="{{'AUTOS.SIMULAR.USO_VEHICULO.MATRICULA' | translate}}"
                type="text"/>
            <ca-error
                *ngIf="form.controls['preg_matricula'].errors?.pattern">{{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>

        </ca-form-field>
        <ca-form-field class="col-4">
            <ca-label>{{'AUTOS.SIMULAR.USO_VEHICULO.BASTIDOR' | translate}}</ca-label>
            <input caInput 
                formControlName="preg_1173"
                placeholder="{{'AUTOS.SIMULAR.USO_VEHICULO.BASTIDOR' | translate}}" 
                type="text"/>
            <ca-error
                *ngIf="form.controls['preg_1173'].errors?.pattern">{{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
        </ca-form-field>
    </div>
    <div class="row mt-3">
        <ca-form-field class="col-4">
            <ca-label>{{'AUTOS.SIMULAR.USO_VEHICULO.TITULO' | translate}}</ca-label>
            <ca-select 
                [options]="usosVehiculo"
                keyValue="descRespuesta"
                valueField="idRespuesta"
                formControlName="preg_2123"></ca-select>
            <ca-error
                *ngIf="form.controls['preg_2123'].errors?.required">{{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
        </ca-form-field>
    </div>
    <div class="row mt-3">
        <ca-form-field class="col-4">
            <ca-label>{{'AUTOS.SIMULAR.USO_VEHICULO.COMPANIA_SEGUROS' | translate}}</ca-label>
            <ca-select 
                [options]="companiasSeguro"
                keyValue="descRespuesta"
                valueField="idRespuesta"
                formControlName="preg_2209"
                virtualScroll></ca-select>
            <ca-error
                *ngIf="form.controls['preg_2209'].errors?.required">{{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
        </ca-form-field>
        <ca-form-field class="col-4">
            <ca-label>{{'AUTOS.SIMULAR.USO_VEHICULO.NUM_POLIZA' | translate}}</ca-label>
            <input caInput 
                formControlName="preg_2210"
                placeholder="{{'AUTOS.SIMULAR.USO_VEHICULO.NUM_POLIZA' | translate}}" 
                type="text"/>
            <ca-error
                *ngIf="form.controls['preg_2210'].errors?.pattern">{{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
        </ca-form-field>
    </div>
</form>